import { IMerchantCoupons } from "@/i/coupons.state.ts";
import { ICoupon } from "@/i/coupon";
import { ITopCouponsItem } from "@/i/top.coupons.state";
import { merchantFactory } from "./merchant";
import vueI18n from "@/i18n.ts";

export const checkTypeAmount = ({ type, value, sign = "%" }): string => {
  return type === "percent" ? `${Math.round(+value)}%` : `${value}${sign}`;
};

export const parseDate = (date: string) => {
  let formattedDate: any = date
    .split("T00")[0]
    .split("-")
    .reverse();
  formattedDate[1] = +formattedDate[1];
  return {
    day: formattedDate[0],
    month: formattedDate[1],
    year: formattedDate[2]
  };
};

export const parseType = (type: string) => {
  const translates = [{ free: "T2" }, { newest: "T3" }, { best: "T4" }];
  let translate = translates.filter(t => t[type])[0];
  return translate ? translate[type] : "";
};

export const checkImg = (img_url, is_https = null) => {
  return !!img_url && is_https ? img_url : null;
};

export const factoryCoupon = (coupon, merchant) => {
  if(!coupon){
    return null
  }

  return {
    title: coupon.title,
    description: coupon.description,
    type: parseType(coupon.coupon_type),
    img: checkImg(merchant.logo, merchant.is_logo_https),
    url: coupon.url,
    date_end: parseDate(coupon.ends),
    coupon_code: coupon.coupon_code ? coupon.coupon_code : vueI18n.t("Z4"),
    discount: coupon.coupon_value
      ? checkTypeAmount(coupon.coupon_value)
      : "SPECIAL",
    merchant_name: merchant.name
  };
};

export const factoryMerchantWithoutCoupon = merchant => {
  return {
    img: checkImg(merchant.logo, merchant.is_logo_https),
    merchant_name: merchant.name,
    merchant_url: merchant.store_url
  };
};

export const factoryMerchantCoupons = (data): IMerchantCoupons => {
  if (data.error) {
    return {
      merchant: {
        id: "",
        logo: "",
        name: "",
        monetizedLink: ""
      },
      countCoupons: 0,
      coupons: [],
      isLoading: false
    };
  }
  const coupons: ICoupon[] = data.coupons.map(c =>
    factoryCoupon(c, data.merchant)
  ).filter(Boolean);
  return {
    merchant: merchantFactory(data.merchant),
    countCoupons: data.couponsCount,
    coupons: coupons,
    isLoading: false
  };
};

export const factoryTopCoupons = (data, type): ITopCouponsItem => {
  const coupons: ICoupon[] = data.coupons.map(c =>
    factoryCoupon(c, c.merchant)
  ).filter(Boolean);
  return {
    coupons: coupons,
    countCoupons: data.couponsCount,
    nextCursor: data.nextCursor
  };
};
